import React from 'react';

const WaitingForOthersIcon = (props) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M11 3C15.97 3 20 7.03 20 12H23L19.11 15.89L19.04 16.03L15 12H18C18 8.13 14.87 5 11 5C7.13 5 4 8.13 4 12C4 15.87 7.13 19 11 19C12.93 19 14.68 18.21 15.94 16.94L17.36 18.36C15.73 19.99 13.49 21 11 21C6.03 21 2 16.97 2 12C2 7.03 6.03 3 11 3ZM12 8V13L7.72 15.54L7 14.33L10.5 12.25V8H12Z" fill="currentColor" />
  </svg>

);

export default WaitingForOthersIcon;
